import { Component, OnInit, ViewChild, TemplateRef, AfterViewInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { UUID } from 'angular2-uuid';
import { POP } from '../../shared/classes/popModel';
import { CropData } from '../../shared/classes/cropdataModel';
import { AuthenticateService } from '../../shared/services/authenticate.service';
import { PopDataComponent } from '../../crophealth-tool/pop-data/pop-data.component';
const now = new Date();
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
// import { Cropsservice } from 'src/app/shared/services/crop.service';
import { CropsService } from 'src/app/shared/services/crops.service';
import { CognitoService } from 'src/app/shared/services/cognito.service';
import { ProfileService } from 'src/app/shared/services/profile.service';
import { TokenStorageService } from 'src/app/shared/services/token.service';


@Component({
  providers: [PopDataComponent],
  selector: 'app-visits',
  templateUrl: './visits.component.html',
  styleUrls: ['./visits.component.sass']
})
export class VisitsComponent implements OnInit {

  @Input() fetchedToolList;
  @Input() numberOfVisits;
  @Input() finalBtntype;
  @Input() profileUuid;
  @Input() mainCropID;
  mainprofileArray: any = [];
  scheduledVisitNumber: any = [];
  tolerance: any = [];
  scheduledVisitName: any = [];
  show: boolean = false;
  popBtnColor = [];
  cropDataBtnColor = [];
  healthBtnColor = [];
  cropdataObj: { orderId: number; ask: string; type: string; response: string; kpi: boolean; };
  cropdataUpdateObj: { orderId: number; ask: string; type: string; response: string; kpi: boolean; }
  qtnAnsArray: any = [];
  cropIndex: any;
  dataId: string = '';
  cropDataGroup: FormGroup;
  cropdata: CropData[];
  editRow: any[] = [];
  kpiName: string;
  showKpiName: boolean = false;
  showmlist: boolean = true;
  healthRowId: string;
  healthDiagnosisIndex: any;
  groupName = this.tokenService.getGroup();
  globalImgUrl = this.authService.s3url();
  healthdiagnosis: any;
  healthArray: any[];
  healthDiagnosisFormGroup: FormGroup;
  editHealth: any[];
  healthObj: {
    name: string;
    healthId: string;
    cropName: string;
    description: string;
    images: any[];
    recommLow: string;
    recommMedium: string;
    recommHigh: string;
    group: string;
  };
  pop: POP[];
  cropNameList: any = [];
  checkList: any = [];
  loading: boolean;
  healthdiagnosisArray: any = [];
  index: number;
  // popIndex: any;
  // popId: any;
  constructor(private _formBuilder: FormBuilder,
    private tokenService: TokenStorageService,
    private authService: AuthenticateService,
    private cropsService: CropsService,
    private profileService: ProfileService,
    private modalService: NgbModal) { }

  ngOnInit() {
    this.profileService.getPopData.subscribe((data) => {
      console.log("PopData", data);
      // this.popId = data['popId'];
      // this.popIndex = data['popIndex'];
      this.popBtnColor[data['popIndex']] = true;
      this.mainprofileArray[data['popIndex']].popId = data['popId'];
      console.log("mainprofileArray", this.mainprofileArray)
      this.pop = [data['popData']]
    })
    this.cropdata = [];
    this.pop = [];
    this.healthdiagnosis = [];
    this.mainprofileArray = [];
    this.popBtnColor = [];
    this.cropDataBtnColor = [];
    this.healthBtnColor = [];
    console.log("fetchedToolList", this.fetchedToolList, this.finalBtntype);
    this.cropDataGroup = this._formBuilder.group({
      orderId: ['', Validators.required],
      ask: ['', Validators.required],
      type: ['', Validators.required],
      response: ['', Validators.required],
      kpi: ['', Validators.required],
      kpiName: [''],
    });
    this.healthDiagnosisFormGroup = this._formBuilder.group({
      recommLow: ['', Validators.required],
      recommMedium: ['', Validators.required],
      recommHigh: ['', Validators.required]
    });
    this.createVisits(this.numberOfVisits);
  }

  numericOnly(event): boolean {
    let patt = /^([0-9])$/;
    let result = patt.test(event.key);
    return result;
  }

  onImgError(event) {
    event.target.src = this.globalImgUrl + 'agri_logo.png';
  }

  createVisits(count) {
    for (var c = 0; c < count; c++) {
      this.popBtnColor[c] = false;
      this.healthBtnColor[c] = false;
      this.cropDataBtnColor[c] = false;
    }
    console.log("visits ", this.fetchedToolList, count);
    this.mainprofileArray = [];
    this.scheduledVisitNumber = [];
    this.scheduledVisitName = [];
    this.tolerance = [];
    var value = 0;
    if (this.fetchedToolList.length > 0) {
      value = this.fetchedToolList[0].collectionData.length
    } else {
      value = 0;
    }
    if (value > 0) {
      this.fetchedToolList[0].collectionData.forEach((element, index) => {
        console.log("index ", index)
        if (element.cropDataId == "") {
          this.cropDataBtnColor[index] = false;
        } else {
          this.cropDataBtnColor[index] = true;
        }
        if (element.popId == "") {
          this.popBtnColor[index] = false;
        } else {
          this.popBtnColor[index] = true;
        }
        if (element.healthDiagnosisId == "") {
          this.healthBtnColor[index] = false;
        } else {
          this.healthBtnColor[index] = true;
        }
        this.mainprofileArray.push(element)
        this.scheduledVisitNumber.push(element.scheduledVisitDay);
        this.scheduledVisitName.push(element.scheduledVisitName);
        this.tolerance.push(element.tolerance)
      });
    }
    for (var i = value; i < count; i++) {
      let obj = {
        orderId: i,
        popId: '',
        cropDataId: '',
        healthDiagnosisId: '',
      }
      this.mainprofileArray.push(obj)
    }
    this.show = true;
    console.log("mainprofileArray : ", this.mainprofileArray);
  }

  deleteVisit(index) {
    console.log("delete main profile array index", this.mainprofileArray[index].orderId);
    let orderid = this.mainprofileArray[index].orderId;
    this.mainprofileArray.splice(index, 1);
    this.scheduledVisitName.splice(index, 1);
    this.scheduledVisitNumber.splice(index, 1);
    this.tolerance.splice(index, 1);
    this.numberOfVisits = this.numberOfVisits - 1;
    if (this.fetchedToolList.length > 0) {
      console.log("this.fetchedToolList ", this.fetchedToolList[0].collectionData[index], orderid, this.fetchedToolList[0].collectionData.map(function (e) { return e.orderId; }).indexOf(orderid));
      let indexOfFetchList = this.fetchedToolList[0].collectionData.map(function (e) { return e.orderId; }).indexOf(orderid);
      if (indexOfFetchList > -1) {
        console.log("deleted...")
        this.fetchedToolList[0].collectionData.splice(indexOfFetchList, 1);
      }
    }
  }

  openCropData(content, data, index) {
    let config: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
    };
    this.qtnAnsArray = [];
    this.dataId = undefined;
    this.cropdataObj = { orderId: null, ask: '', type: '', response: '', kpi: false };
    this.cropdataUpdateObj = { orderId: null, ask: '', type: '', response: '', kpi: false };
    console.log("fetchedToolList ", this.fetchedToolList);
    if (this.fetchedToolList.length == 0) {
      this.dataId = undefined;
      this.qtnAnsArray = [{
        orderId: 1,
        ask: "Farm picture",
        type: "Camera",
        response: "Capture Farm Image",
        kpi: true,
        kpiName: "farmPicture"
      }, {
        orderId: 2,
        ask: "Expected yield",
        type: "number",
        response: "Enter Expected Yield Value",
        kpi: true,
        kpiName: "expectedYield"
      }, {
        orderId: 3,
        ask: "Expected harvest date",
        type: "date",
        response: "Select The Expected Harvest Date",
        kpi: true,
        kpiName: "harvestDate"
      }, {
        orderId: 4,
        ask: "Crop health",
        type: "Single Select",
        response: "Completely healthy,Moderately healthy,Unhealthy",
        kpi: true,
        kpiName: "cropHealth"
      }];
    } else {
      console.log("length---- ", this.fetchedToolList[0].collectionData.length, index);
      if (this.fetchedToolList[0].collectionData.length > index) {
        this.getCropDatafromTool(this.fetchedToolList[0].collectionData[index])
      } else {
        this.dataId = undefined;
        this.qtnAnsArray = [{
          orderId: 1,
          ask: "Farm picture",
          type: "Camera",
          response: "Capture Farm Image",
          kpi: true,
          kpiName: "farmPicture"
        },
        {
          orderId: 2,
          ask: "Expected yield",
          type: "number",
          response: "Enter Expected Yield Value",
          kpi: true,
          kpiName: "expectedYield"
        },
        {
          orderId: 3,
          ask: "Expected harvest date",
          type: "date",
          response: "Select The Expected Harvest Date",
          kpi: true,
          kpiName: "harvestDate"
        },
        {
          orderId: 4,
          ask: "Crop health",
          type: "Single Select",
          response: "Completely healthy,Moderately healthy,Unhealthy",
          kpi: true,
          kpiName: "cropHealth"
        }];
      }
    }
    this.modalService.open(content, config);
    this.cropIndex = index;
  }

  getCropDatafromTool(data) {
    var obj = {
      cropDataId: data.cropDataId,
      group: this.groupName
    }
    this.profileService.getAllCropData(obj).then((data: any) => {
      console.log("getAllCropData result == ", data)
      if (data.length > 0) {
        const indexOfcrop = this.cropdata.map(e => e.cropDataId).indexOf(data[0].cropDataId);
        console.log("index of cropDataId ", indexOfcrop);
        this.dataId = data[0].cropDataId;
        this.qtnAnsArray = data[0].cropData;
      } else {
        this.qtnAnsArray = [{
          orderId: 1,
          ask: "Farm picture",
          type: "Camera",
          response: "Capture Farm Image",
          kpi: true,
          kpiName: "farmPicture"
        },
        {
          orderId: 2,
          ask: "Expected yield",
          type: "TextBox",
          response: "Enter Expected Yield Value",
          kpi: true,
          kpiName: "expectedYield"
        },
        {
          orderId: 3,
          ask: "Expected harvest date",
          type: "date",
          response: "Select The Expected Harvest Date",
          kpi: true,
          kpiName: "harvestDate"
        },
        {
          orderId: 4,
          ask: "Crop health",
          type: "Single Select",
          response: "Completely healthy,Moderately healthy,Unhealthy",
          kpi: true,
          kpiName: "cropHealth"
        }];
      }
    })
  }

  insertIntoTable() {
    this.showmlist = false;
    console.log("insertIntoTable : ", this.cropdataObj);
    if (this.cropdataObj.kpi && this.cropdataObj.kpi == true) {
      if (this.kpiName != null && this.kpiName != '' && this.kpiName != undefined) {
        this.cropdataObj['kpiName'] = this.kpiName;
        let index = this.qtnAnsArray.findIndex(x => x.orderId == this.cropdataObj.orderId);
        if (index === -1) {
          this.qtnAnsArray.push(this.cropdataObj);
          console.log("qtnAnsArray : ", this.qtnAnsArray);
          this.qtnAnsArray.sort((a, b) => Number(a.orderId) - Number(b.orderId));
          console.log("this.qtnAnsArray sorted ", this.qtnAnsArray)
          this.cropdataObj = { orderId: null, ask: '', type: '', response: '', kpi: false };
          this.cropDataGroup.reset();
          this.showKpiName = false;
        } else {
          Swal.fire(
            'Error',
            'Order Id is already exist',
            'error'
          )
        }
      } else {
        Swal.fire(
          'Error',
          'Add kpi name',
          'error'
        )
      }
    } else {
      let index = this.qtnAnsArray.findIndex(x => x.orderId == this.cropdataObj.orderId);
      if (index === -1) {
        this.qtnAnsArray.push(this.cropdataObj);
        console.log("qtnAnsArray : ", this.qtnAnsArray);
        this.qtnAnsArray.sort((a, b) => Number(a.orderId) - Number(b.orderId));
        console.log("this.qtnAnsArray sorted ", this.qtnAnsArray)
        this.cropdataObj = { orderId: null, ask: '', type: '', response: '', kpi: false };
        this.cropDataGroup.reset();
        this.showKpiName = false;
      } else {
        Swal.fire(
          'Error',
          'Order Id is already exist',
          'error'
        )
      }
    }
  }
  editRowData(index) {
    this.cropdataUpdateObj = { orderId: null, ask: '', type: '', response: '', kpi: false };
    this.cropDataGroup.reset();
    this.editRow = [];
    this.editRow[index] = true;
    this.cropdataUpdateObj.orderId = this.qtnAnsArray[index].orderId;
    this.cropdataUpdateObj.ask = this.qtnAnsArray[index].ask;
    this.cropdataUpdateObj.kpi = this.qtnAnsArray[index].kpi;
    this.cropdataUpdateObj.response = this.qtnAnsArray[index].response;
    this.cropdataUpdateObj.type = this.qtnAnsArray[index].type;
  }
  cancelRowEdit(index) {
    this.editRow = [];
    this.editRow[index] = false;
  }

  onChangeKpi(event) {
    console.log("d ", event);
    if (event.currentValue) {
      this.showKpiName = true;
    } else this.showKpiName = false;
  }

  updateRow(index) {
    console.log("this.registerFormUpdateObj ", this.cropdataUpdateObj);
    let i = this.qtnAnsArray.findIndex(x => x.orderId == this.cropdataUpdateObj.orderId);
    console.log("index: ", index, i);
    if (i === index) {
      this.editRow = [];
      this.editRow[index] = false;
      this.qtnAnsArray[index] = this.cropdataUpdateObj;
      this.qtnAnsArray.sort((a, b) => Number(a.orderId) - Number(b.orderId));
      this.cropdataUpdateObj = { orderId: null, ask: '', type: '', response: '', kpi: false };
    } else if (i === -1) {
      this.editRow = [];
      this.editRow[index] = false;
      this.qtnAnsArray[index] = this.cropdataUpdateObj;
      this.qtnAnsArray.sort((a, b) => Number(a.orderId) - Number(b.orderId));
      this.cropdataUpdateObj = { orderId: null, ask: '', type: '', response: '', kpi: false };
    } else {
      Swal.fire(
        'Error',
        'Order Id is already exist',
        'error'
      )
    }
  }

  deleteRow(index) {
    console.log("Deleted!");
    this.qtnAnsArray.splice(index, 1);
  }

  handleInput(e) {
    if (e.which === 32 && e.target.selectionStart === 0) {
      return false;
    }
  }

  openHealthDiagonsis(content, data, index) {
    this.healthRowId = undefined;
    console.log("this.healthArray ", this.healthdiagnosis[index]);
    this.healthDiagnosisIndex = index;
    let config: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      // size:'lg'
    };
    this.modalService.open(content, config);

    this.getAllCrops();
    this.onChangeHealthCropName();
    this.editHealth = [];
    console.log("crop data index ", this.fetchedToolList);

    this.healthArray = []
    this.healthDiagnosisFormGroup.reset();
    this.healthObj = {
      name: '',
      healthId: '',
      cropName: '',
      description: '',
      images: [],
      recommLow: '',
      recommMedium: '',
      recommHigh: '',
      group: ''
    };

    if (this.fetchedToolList.length == 0) {
      this.healthRowId = undefined;
    } else {
      if (this.fetchedToolList[0].collectionData.length > index) {
        this.getHealthfromTool(this.fetchedToolList[0].collectionData[index]);
      } else {
        this.healthRowId = undefined;
      }
    }
  }

  getAllCrops() {
    this.cropNameList = [];
    var options = {
      group: this.groupName,
    }
    this.cropsService.getCropData(options).then((data: any) => {
      console.log("cropData == ", data)
      for (var i = 0; i < data.length; i++) {
        this.cropNameList.push(data[i].cropName);
      }
    })
  }

  changedHealthDiag() {
    setTimeout(() => {
      this.onChangeHealthCropName();
    }, 1000)
  }

  onChangeHealthCropName() {
    this.checkList = [];
    this.healthdiagnosisArray = [];
    console.log("onChangeHealthCropName cropid : ", this.mainCropID, this.healthDiagnosisIndex);
    let obj = {
      group: this.groupName,
      maincropId: this.mainCropID
    }
    this.cropsService.getCropById(obj).then((data: any) => {
      if (data.length != 0) {
        this.loading = true
        console.log("crop name : ", data[0].cropName);
        let cropObj = {
          group: this.groupName,
          cropName: data[0].cropName
        }
        this.profileService.getHealthLib(cropObj).then((data: any) => {
          console.log("heALTH RESULT : ", data);
          this.healthdiagnosisArray = data;
          let healthIdList = []
          this.healthdiagnosisArray.forEach(element => {
            healthIdList.push(element.healthId);
            this.checkList.push(false)
          });
          if (this.healthArray.length > 0) {
            for (let health of this.healthArray) {
              let index = healthIdList.indexOf(health.healthId);
              console.log("healthIdList.indexOf(health) ", healthIdList.indexOf(health.healthId), index);
              this.checkList[index] = true;
            }
          }
          console.log("healthIdList ", healthIdList);
          console.log("this.healthdiagnosis[index] ", this.healthArray);
          this.loading = false
        })
      }
    })
  }

  selectHealth(index, ischecked) {
    console.log("selectHealth ", index, ischecked, this.healthdiagnosisArray[index].healthId);
    let healthId = this.healthdiagnosisArray[index].healthId;
    if (ischecked) {
      console.log(this.healthArray.some(id => id.healthId == healthId))
      if (!this.healthArray.some(id => id.healthId == healthId)) {
        let obj = {
          healthId: this.healthdiagnosisArray[index].healthId,
        }
        this.healthArray.push(obj);
      }
    } else {
      for (var i = 0; i < this.healthArray.length; i++) {
        if (this.healthArray[i].healthId == healthId) {
          console.log("selectHealth.... ", this.healthArray[i].healthId);
          this.healthArray.splice(i, 1);
          break;
        }
      }
    }
    console.log("this.healthArray ", this.healthArray);
  }

  editHealthdiagnosis(index) {
    console.log("edit ", index);
    this.editHealth = [];
    this.editHealth[index] = true;
  }

  closeHealth() {
    this.editHealth = [];
    this.healthDiagnosisFormGroup.reset();
  }

  submitHealthDiagnosis() {
    this.healthBtnColor[this.healthDiagnosisIndex] = true;
    this.editHealth = [];
    if (this.healthRowId == undefined) {
      this.healthRowId = UUID.UUID();
    }
    let obj = {
      profileId: this.profileUuid,
      healthDiagnosisId: this.healthRowId,
      healthCollection: this.healthArray,
      group: this.groupName
    }

    const found = this.healthdiagnosis.some(el => el.healthDiagnosisId === this.healthRowId);
    console.log("found ", found);
    if (!found) {
      this.healthdiagnosis.push(obj);
    }
    if (this.finalBtntype != 'save') {
      this.updateHealthDiagnosis(obj);
    }
    console.log("HEALTH ARRAY : ", this.healthArray, obj);
    this.mainprofileArray[this.healthDiagnosisIndex].healthDiagnosisId = this.healthRowId;
  }

  updateHealthDiagnosis(obj) {
    this.profileService.updateHealthCollection(obj).then((data: any) => {
      console.log("health data", data);
    })
  }

  cancelHealth(index) {
    this.editHealth = [];
    this.editHealth[index] = false;
    this.healthDiagnosisFormGroup.reset();
  }

  healthinput(content) {
    let config: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      // size: 'lg'
    };
    this.modalService.open(content, config);
  }

  getHealthfromTool(fetchedHealth) {
    this.healthArray = [];
    console.log("getHealthfromTool ", fetchedHealth)
    var obj = {
      healthDiagnosisId: fetchedHealth.healthDiagnosisId,
      group: this.groupName
    }
    this.profileService.getAllHealth(obj).then((data: any) => {
      console.log("getAllHealth == ", data);
      if (data.length > 0) {
        const indexOfHealth = this.healthdiagnosis.map(e => e.healthDiagnosisId).indexOf(data[0].healthDiagnosisId);
        this.healthRowId = data[0].healthDiagnosisId;
        this.healthArray = data[0].healthCollection;
      } else {
        const indexOfHealth = this.healthdiagnosis.map(e => e.healthDiagnosisId).indexOf(fetchedHealth.healthDiagnosisId);
        console.log("index of indexOfHealth ", indexOfHealth);
        if (indexOfHealth != -1) {
          this.healthRowId = this.healthdiagnosis[indexOfHealth].healthDiagnosisId;
          this.healthArray = this.healthdiagnosis[indexOfHealth].healthCollection
        }
      }
    });
  }

  openPOP(content, data, index) {
    this.index = index
    let config: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
    };
    this.modalService.open(content, config);
  }

  saveVisitpage() {
    console.log("scheduledVisitNumber ", this.scheduledVisitNumber);
    for (var i = 0; i < this.scheduledVisitNumber.length; i++) {
      this.mainprofileArray[i]['scheduledVisitName'] = this.scheduledVisitName[i]
      this.mainprofileArray[i]['scheduledVisitDay'] = this.scheduledVisitNumber[i];
      this.mainprofileArray[i]['tolerance'] = this.tolerance[i];
    }
    console.log("visit array #second page : ", this.mainprofileArray);
    let tempArray = [];
    let temp = {
      mainProfile: this.mainprofileArray,
      pop: this.pop,
      health: this.healthdiagnosis,
      crop: this.cropdata,
      popBtnColor: this.popBtnColor,
      cropDataBtnColor: this.cropDataBtnColor,
      healthBtnColor: this.healthBtnColor
    }
    this.profileService.sendprofileData(temp);
  }

  saveCropData() {
    this.cropDataBtnColor[this.cropIndex] = true;
    this.showmlist = true;
    if (this.dataId == undefined) {
      this.dataId = UUID.UUID();
    }
    let obj = {
      profileId: this.profileUuid,
      cropDataId: this.dataId,
      cropData: this.qtnAnsArray,
      group: this.groupName,
    }
    const found = this.cropdata.some(el => el.cropDataId === this.dataId);
    console.log("found ", found);
    if (!found) {
      this.cropdata.push(obj);
    }
    if (this.finalBtntype != 'save') {
      this.updateCropData(obj)
    }
    console.log("save cropdataobj : ", this.cropdata, obj);
    this.mainprofileArray[this.cropIndex].cropDataId = this.dataId;
  }

  updateCropData(obj) {
    this.profileService.updateCropdata(obj).then((data: any) => {
      console.log("crop data", data);
    })
  }

  savePOP() {
    console.log("savepop");
    setTimeout(() => {
      this.profileService.savePop();
    }, 1000);
    // this.popcomponent.savePoP();
  }

}
